import React from 'react';
import { Description, Location, Title, Wrapper } from './article.styles';
import { AllLocation } from '@vtbhome/juicyfront/indexIcon';
import { Typography } from '@shared/ui/typography/typography';
import { COLORS } from '@shared/config/colors/colors';
import { ArticleProps } from './types';

export const Article: React.FC<ArticleProps> = ({ product }) => {
    return (
        <Wrapper>
            <Title size='h6'>Информация</Title>
            <Description className='ql-editor' dangerouslySetInnerHTML={{ __html: product.description }} />
            {Boolean(product.place) && (
                <>
                    <Title size='h6'>Место проведения</Title>
                    <Location>
                        <AllLocation size='xxxs' color={COLORS.neutral_50} />
                        <Typography size='subtitle1' color='neutral_50'>
                            {product.place}
                        </Typography>
                    </Location>
                </>
            )}
        </Wrapper>
    );
};
